import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export type LegacyTierFeature = {
  claim: string;
  details?: string[];
  title: string;
};

export type Tier = {
  externalId?: string;
  id?: string;
  maxListings?: number;
  maxSeats?: number;
  maxStorage?: number;
  maxVehicles?: number;
  title?: string;
};

export type TierDetails = {
  additional?: TierFeature[];
  additionalCollaboratorSeatPrice?: number;
  additionalVehicleSlotPrice?: number;
  basePrice: number;
  features?: TierFeature[];
  id: string;
  level: TierLevel;
  productId: string;
  title: string;
};

export type TierFeature = {
  description?: string;
  iconProps?: FontAwesomeIconProps;
  title: string;
};

export type TierInfo = {
  basePrice: number;
  features: LegacyTierFeature[];
  productId: string;
};

const TierLevels = {
  ENTERPRISE: "enterprise",
  ENTHUSIAST: "enthusiast",
  PRO: "pro",
} as const;

export type TierLevel = (typeof TierLevels)[keyof typeof TierLevels];

type NullableTierLevel = null | TierLevel | undefined;

export const TierLevel = {
  ...TierLevels,
  DEFAULT: TierLevels.PRO,
  hasEnterprise: function (tierLevel: NullableTierLevel) {
    return this.isEnterprise(tierLevel);
  },
  hasEnthusiast: function (tierLevel: NullableTierLevel) {
    return (
      this.isEnthusiast(tierLevel) ||
      this.isPro(tierLevel) ||
      this.isEnterprise(tierLevel)
    );
  },
  hasPro: function (tierLevel: NullableTierLevel) {
    return (
      this.isPro(tierLevel) ||
      this.isEnthusiast(tierLevel) ||
      this.isEnterprise(tierLevel)
    );
  },
  isEnterprise: function (tierLevel: NullableTierLevel) {
    return tierLevel === TierLevel.ENTERPRISE;
  },
  isEnthusiast: function (tierLevel: NullableTierLevel) {
    return tierLevel === TierLevel.ENTHUSIAST;
  },
  isPro: function (tierLevel: NullableTierLevel) {
    return tierLevel === TierLevel.PRO;
  },
} as const;
